import React from 'react';

export const AspectSelector = ({ availableAspects, selectedAspects, onToggle, disabled }) => {
  const isSelected = (index) => {
    return selectedAspects.some(a => a.aspectIndex === index);
  };

  if (!availableAspects || availableAspects.length === 0) {
    return (
      <div className="text-gray-500 text-sm">
        No aspects in the current scene. You can submit without referencing any aspects.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-sm text-gray-600">
        Select at least one aspect that your submission references:
      </p>
      <div className="flex flex-wrap gap-2">
        {availableAspects.map((aspect, index) => (
          <button
            key={index}
            onClick={() => !disabled && onToggle(index, aspect.name)}
            disabled={disabled}
            className={`
              px-3 py-1.5 rounded-full text-sm font-medium transition-colors
              ${isSelected(index)
                ? 'bg-primary-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            {aspect.name}
          </button>
        ))}
      </div>
      {selectedAspects.length === 0 && (
        <p className="text-sm text-amber-600">
          You must select at least one aspect to submit.
        </p>
      )}
    </div>
  );
};
